var React = require('react');

function ToolMui (props) {
    return React.createElement("svg",props,[React.createElement("g",{"className":"fill-border","key":0},[React.createElement("path",{"d":"M3.8,12.6V5.5L10,9v2.4L5.9,9v4.7L3.8,12.6z","key":0}),React.createElement("path",{"d":"M10,13.8v2.4l4.1,2.4v-2.4L10,13.8z","key":1})]),React.createElement("g",{"className":"fill-foreground","key":1},[React.createElement("polygon",{"points":"10,9 16.1,5.5 16.1,12.6 12,15 10,13.8 14,11.4 14,9 10,11.4 \t","key":0}),React.createElement("path",{"d":"M14,18.5l6.1-3.5v-4.7l-2,1.2v2.4L14,16.1V18.5z M18.1,9V6.7l2-1.2v2.4L18.1,9z","key":1})])]);
}

ToolMui.defaultProps = {"version":"1.0","width":"48","height":"48","viewBox":"0 0 24 24"};

module.exports = ToolMui;

ToolMui.default = ToolMui;
